export default "__VITE_ASSET__7a308bce__"